module.exports = __webpack_public_path__ + "bluelotusdots.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bluelotusdots.png
// module id = 876
// module chunks = 0